import type { Insight } from "@tandemdiabetes/sugarmate-api-react-client"
import { usePolyglot } from "src/contexts"

interface Props {
  range: Insight["range"];
}

export function InsightRangeString(props: Props) {
  const { range } = props

  const polyglot = usePolyglot()

  if (range === null) {
    return (
      <>
        {polyglot.t("time.up_to_now")}
      </>
    )
  }

  if (range === 0) {
    return (
      <>
        {polyglot.t("time.since_wake_up")}
      </>
    )
  }

  if (range <= 1) {
    return (
      <>
        {polyglot.t(
          "time.minute",
          Math.round(range * 60),
        )}
      </>
    )
  }

  if (range <= 24) {
    return (
      <>
        {polyglot.t(
          "time.num_hour",
          Math.round(range),
        )}
      </>
    )
  }

  return (
    <>
      {polyglot.t(
        "time.day",
        Math.round(range / 24),
      )}
    </>
  )
}
